export const ThemeColors = {
  green: 'green',
  blue: 'blue',
  yellow: 'yellow',
  purple: 'purple',
} as const;

export type ThemeColor = (typeof ThemeColors)[keyof typeof ThemeColors];

// Pill button variant (src/components/ui/button) that matches each theme's accent colour.
export const THEME_PILL_VARIANT = {
  green: 'pill-green',
  blue: 'pill-blue',
  yellow: 'pill-yellow',
  purple: 'pill-purple',
} as const satisfies Record<ThemeColor, string>;
